function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  width: "100",
  height: "100",
  xmlns: "http://www.w3.org/2000/svg"
}, props), React.createElement("title", null, "icon-business"), React.createElement("g", {
  id: "icon-business-icon-business",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M70.5945725,77.0191743 C70.721917,77.9247264 70.4462263,78.8406189 69.8401754,79.5254133 L52.6526754,98.9460634 C51.409014,100.351312 49.2160286,100.351312 47.9723672,98.9460634 L30.7848672,79.5254133 C30.1788162,78.8406189 29.9031255,77.9247264 30.03047,77.0191743 L37.7466748,22.1489193 L30.7847349,14.2814109 C29.7382658,13.0988233 29.7384732,11.3213802 30.7852183,10.1390368 L38.8287352,1.05353987 C39.4218675,0.383571541 40.2737402,0 41.1685382,0 L59.4565043,0 C60.3513023,0 61.203175,0.383571541 61.7963073,1.05353987 L69.8398242,10.1390368 C70.8865693,11.3213802 70.8867767,13.0988233 69.8403076,14.2814109 L62.8783677,22.1489193 L70.5945725,77.0191743 Z M37.2982856,12.210984 L42.4493967,18.0321215 L58.1756458,18.0321215 L63.326757,12.210984 L58.0494149,6.25 L42.5756276,6.25 L37.2982856,12.210984 Z M36.4202556,76.4624591 L50.3125213,92.1597292 L64.2047869,76.4624591 L56.8668829,24.2823168 L43.7581596,24.2823168 L36.4202556,76.4624591 Z",
  id: "icon-business-Combined-Shape",
  fill: "#000",
  fillRule: "nonzero"
}))));